module.exports = __webpack_public_path__ + "static/media/f_hairstyle_wavy_long_back_vector.21e619a4.svg";